(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__stitchProductCard) return;
    window.__stitchProductCard = true;

    const WISH_KEY = 'stitch-wishlist';
    const COMPARE_KEY = 'stitch-compare';
    const COMPARE_MAX = 4;

    const readList = (key) => {
      try {
        const raw = JSON.parse(localStorage.getItem(key) || '[]');
        return Array.isArray(raw) ? raw : [];
      } catch (error) {
        return [];
      }
    };

    const writeList = (key, list) => {
      localStorage.setItem(key, JSON.stringify(list));
    };

    const productFromButton = (button) => ({
      id: String(button.dataset.productId || ''),
      title: button.dataset.productTitle || '',
      url: button.dataset.productUrl || '',
      image: button.dataset.productImage || '',
      price: button.dataset.productPrice || ''
    });

    const showToast = (message) => {
      if (!message) return;
      let toast = document.querySelector('[data-product-card-toast]');
      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'product-card-toast';
        toast.setAttribute('data-product-card-toast', '');
        toast.setAttribute('role', 'status');
        document.body.appendChild(toast);
      }
      toast.textContent = message;
      toast.classList.add('is-visible');
      window.clearTimeout(showToast._timer);
      showToast._timer = window.setTimeout(() => {
        toast.classList.remove('is-visible');
      }, 1800);
    };

    const syncButtons = () => {
      const wishlist = readList(WISH_KEY).map((item) => String(item.id || item));
      const compare = readList(COMPARE_KEY).map((item) => String(item.id || item));

      document.querySelectorAll('[data-wishlist][data-product-id]').forEach((button) => {
        const active = wishlist.includes(String(button.dataset.productId));
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      document.querySelectorAll('[data-compare][data-product-id]').forEach((button) => {
        const active = compare.includes(String(button.dataset.productId));
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };

    document.addEventListener('click', (event) => {
      const wishBtn = event.target.closest('[data-wishlist][data-product-id]');
      if (wishBtn) {
        event.preventDefault();
        event.stopPropagation();
        const item = productFromButton(wishBtn);
        if (!item.id) return;
        const list = readList(WISH_KEY);
        const exists = list.some((entry) => String(entry.id || entry) === item.id);
        const next = exists
          ? list.filter((entry) => String(entry.id || entry) !== item.id)
          : list.concat(item);
        writeList(WISH_KEY, next);
        syncButtons();
        document.dispatchEvent(new CustomEvent('stitch:wishlist-change', { detail: { count: next.length } }));
        if (window.StitchWishlist?.syncCount) window.StitchWishlist.syncCount();
        showToast(exists ? 'Removed from wishlist' : 'Saved to wishlist');
        return;
      }

      const compareBtn = event.target.closest('[data-compare][data-product-id]');
      if (compareBtn) {
        event.preventDefault();
        event.stopPropagation();
        const item = productFromButton(compareBtn);
        if (!item.id) return;
        const list = readList(COMPARE_KEY);
        const exists = list.some((entry) => String(entry.id || entry) === item.id);
        if (exists) {
          writeList(
            COMPARE_KEY,
            list.filter((entry) => String(entry.id || entry) !== item.id)
          );
          syncButtons();
          showToast('Removed from compare');
          return;
        }
        if (list.length >= COMPARE_MAX) {
          showToast('Compare list is full (max 4)');
          return;
        }
        writeList(COMPARE_KEY, list.concat(item));
        syncButtons();
        showToast(`Added to compare (${list.length + 1}/${COMPARE_MAX})`);
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncButtons);
    } else {
      syncButtons();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
